
define('ldsh!modules/form_editor/templates/preview_custom_googlecaptcha', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-item-captcha">\n  <div id="' +
((__t = ( idName )) == null ? '' : __t) +
'" class="ed-captcha-block ed-google-recaptcha"></div>\n</div>\n';

}
return __p
};});

